var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPitchbook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8508 3C5.63806 3.72148 1.80868 11.1721 3.32101 15.8617C4.22285 14.5298 5.8878 13.0868 9.24544 12.5318C9.06507 8.5637 10.5497 5.81654 14.8508 3Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1192 13.0869C7.77435 13.4477 6.17878 14.0582 5.13818 15.0016C5.17981 16.2503 5.54055 17.4713 6.17878 18.5396C6.96963 16.6666 9.53642 15.3207 13.4768 15.3207C12.5056 10.8393 14.6284 6.71852 17.9999 3.9436C16.3488 4.1656 14.7394 4.59571 13.1993 5.20619C10.688 7.59261 9.75841 10.6589 10.1192 13.0869Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPitchbook);
export default __webpack_public_path__ + "static/media/pitchbook.b080a6ed2bd492579bd94f579256b2a2.svg";
export { ForwardRef as ReactComponent };